import React, { useState, useEffect } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { getDynamicHostelFoodMenu, deleteHostelFoodMenu } from "../../../services/OrganisationServices/hostelManagmentService";
import { useParams } from "react-router-dom";
import AddFoodMenuComponent from "./add-food-menu-form";
import {
  useSharedState,
  useGlobalState,
} from "../../../services/hostelConst.js";
const HostelDynamicFoodMenuTable = () => {
  const [sharedState, setSharedState] = useSharedState();
  const { hostelMenuState, toggleHostelMenu, openModal, modalState } =
    useGlobalState();

  var { id } = useParams();

  useEffect(() => {
    openModal({ ...modalState, id: id });
    setSharedState(true);
  }, []);
  return (
    <MasterTable
      getTableData={getDynamicHostelFoodMenu}
      tab1={"Hostel"}
      hostelId={id}
      tab2={"Food Menu"}
      AddForm={AddFoodMenuComponent}
      externalPermis={{
        POST: 1,
        GET: 1,
        PUT: 0,
        DELETE: 1,
        PATCH: 1,
      }}
      deleteRow={deleteHostelFoodMenu}
      actions={{
        // status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default HostelDynamicFoodMenuTable;
